const state = {
    layer_login_open: false,
}

const mutations = {
    SET_LAYER_LOGIN_OPEN: (state, open) => {
        state.layer_login_open = open
    },
}

const actions = {
    login_open({ commit }) {
        commit('SET_LAYER_LOGIN_OPEN', true)
    },
    login_close({ commit }) {
        commit('SET_LAYER_LOGIN_OPEN', false)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
